import { render, staticRenderFns } from "./ImagesList.vue?vue&type=template&id=35610755&scoped=true"
import script from "./ImagesList.vue?vue&type=script&lang=js"
export * from "./ImagesList.vue?vue&type=script&lang=js"
import style0 from "./ImagesList.vue?vue&type=style&index=0&id=35610755&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35610755",
  null
  
)

export default component.exports